import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { tokenManager } from '../services/tokenManager';

const ProtectedRoute = ({ children, allowedRoles = [], requireAuth = true }) => {
  const location = useLocation();
  const user = tokenManager.getUser();
  const isAuthenticated = tokenManager.isAuthenticated();

  // If authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    console.log('User not authenticated, redirecting to login');
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If user is authenticated but doesn't have the required role
  if (requireAuth && isAuthenticated && allowedRoles.length > 0) {
    const userRole = user?.role;
    
    if (!userRole || !allowedRoles.includes(userRole)) {
      console.log(`User role '${userRole}' not authorized for this route. Allowed roles: ${allowedRoles.join(', ')}`);
      
      // Redirect based on user's actual role
      switch (userRole) {
        case 'admin':
          return <Navigate to="/admin/dashboard" replace />;
        case 'psychiatrist':
          return <Navigate to="/psy/dashboard" replace />;
        case 'nurse':
          return <Navigate to="/nurse/dashboard" replace />;
        case 'patient':
        default:
          return <Navigate to="/dashboard" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute; 